import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalContainer = styled(Modal)`
  .button-previous {
    margin: 0 8px;
  }

  .button-download {
    padding: 0;
  }

  .ant-steps {
    margin-bottom: 15px;
  }

  .action-activation,
  .action-validation,
  .action-network-reset {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .action-activation {
    .ant-row,
    .ant-select {
      width: 100%;
    }
  }

  .action-operator-restriction {
    .ant-select {
      width: 90%;
    }
  }

  .action-network-block-unlock {
    padding: 24px;
    width: 100%;
    display: flex;
    justify-content: center;

    .action-network-block-unlock-radio {
      padding: 16px;
      max-width: 160px;
      width: 100%;
      height: 100%;
      text-align: center;
      &:hover span > div {
        opacity: 0.6;
      }
      span > div {
        margin: 0 auto;
        margin-bottom: 4px;
      }
    }
  }

  .block-types-tabs {
    .ant-tabs-tab {
      border-color: #dbdbdb;
    }
  }
`;
